import gql from 'graphql-tag';

export const GET_TRANSACTIONS_LIST = gql`
  query GetTransactionsList(
    $companyId: String!,
    $periodId: String!,
    $accountId: String,
    $pagination:PaginationInputType!
    $transactionDocConnections: Boolean,
    $transactionType: String,
    $search: String
    $dateStart: String,
    $dateEnd: String,
    $docNeeded: Boolean,
    $reason: String
  ) {
    banking {
      getTransactionsList(
        companyId: $companyId
        periodId: $periodId
        accountId: $accountId
        pagination: $pagination
        transactionDocConnections: $transactionDocConnections,
        transactionType: $transactionType,
        search: $search
        dateStart: $dateStart
        dateEnd: $dateEnd
        docNeeded: $docNeeded
        reason: $reason
      ) {
        list {
          account {
            id
            accountName
            currency
            iban
          }
          transactionId
          transactionDate
          status
          transactionType
          mode
          counterpartyId
          counterpartyName
          counterparty {
            idNumber
            firstName
            lastName
            middleName
          }
          note
          currency
          amount
          sourceCurrency
          sourceAmount
          comment
          transactionDocConnectionsCount
          docNeeded
          reason
          reasonNotNeeded
          extraTaxAgree
          bankingCategoryItem {
            id
            name
          }
        }
        pagination {
          total
        }
      }
    }
  }`;

export const GET_TRANSACTION_DOC_CONNECTIONS_BY_ID = gql`
  query getAccountingFilesByTransactionId($companyId: String!, $transactionId: String!) {
    banking {
      getAccountingFilesByTransactionId(companyId: $companyId, transactionId: $transactionId) {
        accStatusId
        id
        isRead
        meritInvoiceId
        meritRefNo
        meritShipmentStatus
        meritShipmentError
        name
        rejectionReasonId
        rejectionComment
        periodsSubfolderId
        status
        source
        customerVatNumber
        periodsSubfolderId
        periodsSubfolder {
          type
        }
        moniteInvoice {
          documentType
        }
      }
    }
  }
`;

export const GET_LOCATION_DOCUMENT = gql`
  query GetDocLocation($fileId: String!) {
    accounting {
      getDocLocation(fileId: $fileId) {
        companyId
        companyFolderId
        yearFolderId
        periodFolderId
        periodSubfolderId
        contractsFolderId
      }
    }
  }
`;

export const GET_BALANCE_INFO = gql`
  query GetBalanceInfoByPeriod($accountId: String!, $startDate: String, $endDate: String, $periodFolderId: String) {
    banking {
      getBalanceInfoByPeriod(accountId: $accountId, startDate: $startDate, endDate: $endDate, periodFolderId: $periodFolderId) {
        startFinalBalance
        startClosingBalance
        finalBalance
        finalClosingBalance
        debitTurnover
        creditTurnover
      }
    }
  }
`;
